import { WarningCircle } from "@phosphor-icons/react";
import { Button } from "@/components/primitives/Button";
import { Modal } from "../Modal";
import type { ConfirmDialogProps } from "./ConfirmDialog.types";

export function ConfirmDialog({
  open,
  defaultOpen,
  onOpenChange,
  onClose,
  title,
  description,
  confirmLabel = "Confirm",
  cancelLabel = "Cancel",
  onConfirm,
  onCancel,
  loading,
  destructive,
  disabledConfirm,
  icon,
  children,
  className
}: ConfirmDialogProps) {
  const handleCancel = () => {
    onCancel?.();
    onOpenChange?.(false);
    onClose?.();
  };

  return (
    <Modal
      open={open}
      defaultOpen={defaultOpen}
      onOpenChange={onOpenChange}
      onClose={onClose}
      title={title}
      description={description}
      size="sm"
      preventClose={loading}
      className={className}
      footer={
        <>
          <Button variant="secondary" onClick={handleCancel} disabled={loading}>
            {cancelLabel}
          </Button>
          <Button variant={destructive ? "destructive" : "primary"} loading={loading} disabled={disabledConfirm} onClick={() => void onConfirm?.()}>
            {confirmLabel}
          </Button>
        </>
      }
    >
      {(icon || destructive) && <div className="bfrs-mb-4 bfrs-flex bfrs-size-11 bfrs-items-center bfrs-justify-center bfrs-rounded-pill bfrs-bg-danger-soft bfrs-text-danger">{icon ?? <WarningCircle size={24} weight="duotone" />}</div>}
      {children}
    </Modal>
  );
}
